const applyAiQuantity = (material, aiGroup) => {
  if (!material?.estimateAiQuantity) {
    return material;
  }

  const aiMatch = (aiGroup?.materials || []).find((aiMat) => aiMat?.intent === material.intent);

  if (aiMatch) {
    return {
      ...material,
      quantity: aiMatch.quantity ?? material.quantity,
      aiQuantity: aiMatch.quantity || 0,
      calcBase: aiMatch.calculationBasis || null,
    };
  }

  return material;
};

export const mergeAiQuantities = (intentGroups, materialsGroups) => {
  return intentGroups.map((group) => {
    const aiGroup = materialsGroups.find((ag) => ag.groupName === group.groupName);
    return {
      ...group,
      materials: (group.materials || []).map(
        (material) => applyAiQuantity(material, aiGroup)
      ),
    };
  });
};
